import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetParamWithNestedParent,
    asyncGetSubmotive4Historical,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { SUBMOTIVE4 } from '../../../../../routes/paths';

export const useSubmotive4Detail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idSubmotive4 } = useParams();
    const [loading, setLoading] = useState(false);
    const [submotive4, setSubmotive4] = useState<Param>();
    const [submotive4Historical, setSubmotive4Historical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idSubmotive4)) {
            setLoading(true);
            asyncGetParamWithNestedParent(idSubmotive4, 5)
                .then((submotive4: any) => {
                    if (!submotive4 || !submotive4.items) navigate(SUBMOTIVE4);
                    setSubmotive4(submotive4?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idSubmotive4]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetSubmotive4Historical(idSubmotive4)
                .then((resp) => {
                    if (resp) setSubmotive4Historical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        submotive4,
        submotive4Historical,
        showHistorical,
        setShowHistorical,
    };
};
